<template>
  <view class="service-notice">
    <view wx:for="{{ notices }}" wx:key="index" bindtap="goServicePage(item.url)">{{item.title}}</view>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'
  import { goto } from '@didi/spring-base'

  createComponent({
    props: {
      isJhAliMini: Boolean,
      notices: {
        type: Array
      }
    },
    methods: {
      goServicePage(url) {
        goto({ url })
      },
    }
  })
</script>

<style lang="stylus" scoped>
  .service-notice
    font-family PingFangSC-Regular
    font-size 12px
    line-height 14px
    padding 16px 0
    color #748AAF
    display flex
    flex-direction column
    align-items center
</style>
